import { HealthLang } from "../health/healthTypes";

export function agentsLocalePath(path: string, lang: HealthLang): string {
    if (path.startsWith("http") || path.startsWith("mailto")) return path;
    if (path.startsWith("#")) return path;
    if (lang === "Zh" && path.startsWith("/")) return `/tw${path}`;
    if (lang === "Jp" && path.startsWith("/")) return `/jp${path}`;
    return path;
}
